export default __webpack_public_path__ + "static/media/1819 utensils side.b119c2de.png";